export default __webpack_public_path__ + "static/media/icon-instagram.417a0bd9.png";